module.exports = __webpack_public_path__ + "static/media/boltbox_login_bg.7f6a1363.png";